// @ts-expect-error - gif.js doesn't have TypeScript definitions
import GIF from 'gif.js'

export interface GIFEncoderOptions {
  width: number
  height: number
  framerate: number
  quality?: number // 1-10, lower is better quality
  workers?: number
}

export class GIFEncoder {
  private gif: any

  constructor(options: GIFEncoderOptions) {
    this.gif = new GIF({
      width: options.width,
      height: options.height,
      quality: options.quality || 10,
      workers: options.workers || 4,
      workerScript: '/gif.worker.js' // Will be served from public folder
    })
  }

  addFrame(imageData: ImageData | HTMLCanvasElement, delay: number) {
    // copy: gif.js otherwise keeps a reference to the canvas and reads it only when encoding,
    // so every frame would be the canvas's final contents
    this.gif.addFrame(imageData, { delay, copy: true })
  }

  async render(): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      this.gif.on('finished', (blob: Blob) => {
        blob.arrayBuffer().then(resolve).catch(reject)
      })

      this.gif.on('error', reject)

      this.gif.render()
    })
  }

  abort() {
    this.gif.abort()
  }
}